<div class="header">
    <span>
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </span>
</div>
<div class="container mat_step_container" style="min-height: 700px !important">
    <div class="row" align="right">
        <button class="btn_salir" mat-button (click)="cerrar_vista()">Salir</button>
    </div>
    <div class="row" style="width: 100%; height: 100px;">
        <div>
            <h1 class="title-section">INFORMACIÓN GENERAL</h1>
        </div>

    </div>

    <div class="opciones">
        <div class="container" *ngIf="listDocs.length>0">
            <div class="row" *ngFor="let doc of listDocs">
                <div class="col-md-2"></div>
                <div class="col-md-8" style="padding-top: 10px;">
                    <div class="row link-docs-pa">
                        <div class="col-sm-10"><span>{{doc.fieldData.Nombre_documento!=""?doc.fieldData.Nombre_documento:"Sin título"}}{{(doc.fieldData.Resumen)?', '+doc.fieldData.Resumen:''}}</span></div>
                        <div class="col-sm-2"><button class="button-special-info-pa" (click)="moreInfo(doc)">Más Info</button></div>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
            <!--
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8 margin" style="padding-top: 10px;">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                        <ng-container matColumnDef="num">
                            <th mat-header-cell *matHeaderCellDef style="    width: 50px;"> No. </th>
                            <td mat-cell *matCellDef="let element; let i = index;"> {{i + 1}} </td>
                        </ng-container>
       
                        <ng-container matColumnDef="nom">
                            <th mat-header-cell *matHeaderCellDef> Nombre del documento </th>
                            <td mat-cell *matCellDef="let element" style="    width: 110px;     padding-right: 4%;">
                                  {{element.fieldData.Nombre_documento != "" ?  element.fieldData.Nombre_documento : "Sin título" }}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="res">
                            <th mat-header-cell *matHeaderCellDef style="    width: 110px;"> Descripción del documento </th>
                            <td mat-cell *matCellDef="let element">
                                 {{element.fieldData.Resumen}}
                            </td>
                        </ng-container>
        
                        <ng-container matColumnDef="opt">
                            <th mat-header-cell *matHeaderCellDef style="width: 150px; text-align: center;"> Descargar </th>
                            <td mat-cell *matCellDef="let element" style="text-align: center;">
                                <a class="img-card" (click)="download(element)" style="display: inline-flex; cursor: pointer;">
                                    <img src="/assets/icons/pdf.png" style="    width: 50px;" />
                                </a>
                            </td>
                        </ng-container>
        
        
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"></tr>
                    </table>       
                </div>
                <div class="col-md-2"></div>
            </div>
            -->
        </div>


    </div>

</div>